import { customerSelectorToolbarStyles } from "@insite/content-library/Components/CustomerSelectorToolbar";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

customerSelectorToolbarStyles.searchTextField = {
    cssOverrides: {
        formField: css`
            flex-basis: 50%;
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                   flex-basis: 55%;
                   div {
                    input {
                        font-size: 14px !important;
                        padding: 0px 2px !important;
                    }
                    span {
                        padding: 0 !important;
                        padding-left: 13px !important;
                    }
                   }
                `,
                null,
                null,
                null,
                null
            ])}
        `,
    },
}

customerSelectorToolbarStyles.searchButton = {
    mergeCss:true,
    variant: "primary",
    css: css`
        margin-left: auto;
    `,
}

customerSelectorToolbarStyles.wideCreateNewAddressButton = {
    mergeCss:true,
    variant: "secondary",
    css: css`
        margin-left: 10px;
    `,
}

customerSelectorToolbarStyles.overflowMenu = {
    cssOverrides: {
        wrapper: css`
            button {
                min-width: 100%;
                &:hover {
                    border: none !important;
                    background: none !important;
                }
                &:focus {
                    outline: none !important;
                }
            }
        `,
    },
}